import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../../core/redux/api/reduxStandardApiAction';
import { IAppState } from '../../core/redux/IAppState';
import { ACTION_TYPE } from '../../core/redux/actionType';
import { hasTrippedBreaker, updateBreaker } from '../../core/redux/api/circuitBreaker/module';
import { addError, addLoading, getLoading, removeLoadingAndError } from '../../core/redux/api/module';
import { User } from './user';
import {API_GET_USERS_BY_RESORT} from '../../core/redux/api/endpoints';
import { assoc } from '../../language/module';
import { getResource } from '../../language/resources/getResource';


export const KEY_ACTION = ACTION_TYPE.GET_USERS_REQUEST;
export const ACTIONS    = [
  ACTION_TYPE.GET_USERS_REQUEST,
  ACTION_TYPE.GET_USERS_RESPONSE,
  ACTION_TYPE.GET_USERS_ERROR,
];


/**
 * An action to dispatch to get the complete list of Resort Tools users at this resort.
 */
export const getUsersAction = (resortId: number) => makeApiAction(
  {
    method:   'GET',
    headers:  (state: IAppState) => ({
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    endpoint: API_GET_USERS_BY_RESORT(resortId),
    types:    ACTIONS.map(action => ({ type: action })) as RsaaTypes,
    bailout:  (state: IAppState) => hasTrippedBreaker(state, KEY_ACTION) || !!getLoading(state, KEY_ACTION, KEY_ACTION),
  },
);


const reducer: ApiReducer<User[]> = (state, action, error, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error || !payload) {
    return addError(withBreaker, KEY_ACTION, KEY_ACTION, error ?? getResource(state.locale, 'GET_USERS_ACTION_ERROR'));
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, KEY_ACTION, KEY_ACTION);

  return assoc('users', payload, noLoadingOrError);
};


export const getUsersReducer = makeApiReducer<User[]>(ACTIONS, KEY_ACTION, reducer);
